<!-- <div class="flex-end">
    <button mat-icon-button style="background-color: white; color: #6f0b0f;"
     class="small-icon-button" (click)="closeModal()"> 
        <mat-icon>close</mat-icon> 
    </button>
</div>     -->

<div class="flex-center" style="padding-right: 21px;">
    <div>
        <mat-icon style="font-size: 43px; color: #6f0b0f;">error_outline</mat-icon>
    </div>
</div>

<div style="font-size: 18px; text-align: center; margin-top: 8px; color: #6f0b0f; font-weight: 600;">
    Are you sure?
</div>

<div style="text-align: center; font-size: 15px; margin-top: 11px; font-weight: 400; color: #887b7b;">
    Do you really want to delete? This cannot be undone
</div>

<div class="flex-center mt-2">
    <button mat-button style="color: white; background-color: #c5c2c2a6; padding: 2px 15px; font-size: 13px;" (click)="closeModal()">
        Cancel
    </button>

    &nbsp;
    &nbsp;

    <button mat-button style="color: white; background-color: #6f0b0f; padding: 2px 15px; font-size: 13px;" (click)="delete()">
        Delete
    </button>
</div>